import { LayoutMain } from "@unisearch/theme/layout";
import EventsDetailsBackup from "@modules/events/details_backup";

const EventsDetailPage = () => {
  return (
    <LayoutMain
      title="New Trends in Teaching, Learning & Education"
      metaTitle="New Trends in Teaching, Learning & Education"
      metaImage={""}
      metaDescription="New Trends in Teaching, Learning & Education"
      metaKeywords="event, fair, virtual, virtual fair"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/events/details`}
    >
      <EventsDetailsBackup />
    </LayoutMain>
  );
};

export default EventsDetailPage;
